import _ from 'lodash';
import fs from 'fs-extra';
import path from 'path';
import { log } from '@swiper/core';
import config from '~/config';
import { Service } from './Service';
import globby from 'globby';
import Promise from 'bluebird';
import matter from 'gray-matter';

export class InfoService extends Service {

  get name() { return 'info'; }

  constructor( opts ) {
    super( opts );
    if ( ! this.dir ) this.dir = config.dir( 'info' );
  }

  get dirs() {
    return _.flattenDeep( [
      path.resolve( require.resolve( '@swiper/core' ), '../../info' ),
      this.dir,
    ] );
  }

  async load( id, file ) {
    log.debug( 'InfoService.load', id );
    if ( ! file ) file = await this.locate( id );
    log.debug( 'LOCATED', file );
    const text = await fs.readFile( file );
    const { data, content } = matter( text );
    _.assign( data, { id, content } );
    if ( ! data.title ) data.title = this.extractTitle( content );
    return data;
  }

  extractTitle( text ) {
    const lines = text.split( /[\r\n]+/u ).slice( 0, 5 ).map( l => l.trim() );
    const x = lines[0].match( /^#\s*(.*)\s*#$/u );
    if ( x ) return x[1];
  }

  async idMap() {
    return Promise.map( this.dirs, async dir => {
      return Promise.map( globby( [
        '**/*.{md,mkd,markdown}',
        '!_*/**', // Ignore top-level directories starting with _
      ], {
        cwd       : dir,
        deep      : true,
        onlyFiles : true,
        globstar  : false,
        extglob   : false,
      } ), file => {
        log.debug( 'DIR:', dir );
        log.debug( 'FILE:', file );
        const full = path.resolve( dir, file );
        const id = file.replace( /\.(mk?d|markdown)$/u, '' );
        return { id, file, full, dir };
      } ).catch( err => {
        if ( err.code === 'ENOENT' ) return [];
        throw err;
      } );
    } ).then( _.flattenDeep ).then( files => {
      console.log( 'FILES', files );
      return files;
    } );
  }

  async loadAll() {
    const map = await this.idMap();
    log.debug( 'IDMAP', map );
    return Promise.map( map, ( { id, full } ) => {
      console.log( 'Loading', id, 'from', full );
      return this.load( id, full );
    } );
  }

  async locate( id ) {
    for ( const dir of this.dirs ) {
      const file = path.resolve( dir, id + '.md' );
      console.log( 'CHECKING FOR FILE IN', file );
      // eslint-disable-next-line no-await-in-loop
      if ( await fs.exists( file ) ) {
        console.log( 'FOUND', file );
        return file;
      }
    }
  }

  async find( { query, ...params } ) {
    return _.filter( await this.loadAll(), query );
  }

  async get( id, params ) {
    return this.load( id );
  }

  /*
   * Although this services uses "find" and "get" to retrieve
   * information files, you can't create those files through the service
   * itself, they only get created by syncing files into the data
   * directory.  So instead we have co-opted the "create" method to
   * allow creating any other random informational messages, just to
   * allow that information to be broadcast to the clients.  At the
   * pool, for example this powers the temperature displays on the
   * idle page.
   */
  async create( id, data, params ) {
    return { id, data };
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
